var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
var PopularLeagues = function (props) {
    var league = props.league;
    var leagueId = league.get('id');
    var name = league.get('name');
    var sportId = league.get('sportId');
    var eventCount = league.get('eventCount');
    return (_jsx("div", __assign({ className: 'item soccer' }, { children: _jsx(Link, __assign({ to: "/sport/".concat(sportId, "/").concat(leagueId), id: "league-".concat(leagueId) }, { children: _jsxs("div", __assign({ className: 'name' }, { children: [name, _jsx("div", __assign({ className: 'all' }, { children: eventCount }))] })) })) })));
};
PopularLeagues.propTypes = {
    league: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
};
function mapStateToProps(state, props) {
    var id = props.id, section = props.section;
    var league = state.application.getIn([section, 'leagues', id]);
    return {
        league: league
    };
}
export default connect(mapStateToProps)(PopularLeagues);



// WEBPACK FOOTER //
// ./src/components/grid/sports/PopularLeagues.jsx